/**
 * "42s ago" — never a timestamp.
 *
 * Every time on the football status panel answers "is this stale", and nobody subtracts ISO
 * instants in their head at 3pm on a Saturday. Its own module because the panel file exports a
 * component and nothing else.
 */
export function relativeTime(iso: string | null, nowMs: number): string {
  if (!iso) return 'never'
  const seconds = Math.max(0, Math.round((nowMs - Date.parse(iso)) / 1000))
  if (seconds < 60) return `${seconds}s ago`
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`
  if (seconds < 86_400) return `${Math.floor(seconds / 3600)}h ago`
  return `${Math.floor(seconds / 86_400)}d ago`
}
